import React from 'react';
import { normalizeEmail } from 'utils';
import { InvitedBroker } from '../../../../models/InvitedBroker';
import { InvitedBrokerTable } from './data';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import XcircleIcon from 'icons/Xcircle.icon';

type CellProps = {
  broker: InvitedBroker;
};

const NameCell: React.FC<CellProps> = ({ broker }) => {
  const { firstName, lastName } = broker;

  return (
    <div className="pdt-name-cell">
      {firstName} {lastName}
    </div>
  );
};

const EmailCell: React.FC<CellProps> = ({ broker }) => {
  const { email } = broker;

  if (!email) return null;

  return <div className="pdt-email-cell">{normalizeEmail(email)}</div>;
};

const AcceptedCell: React.FC<CellProps> = ({ broker }) => {
  const { isBrokerAccepted } = broker;

  return (
    <div className="pdt-is-accepted-cell">
      {isBrokerAccepted ? (
        <CheckcircleIcon className="accepted" />
      ) : (
        <XcircleIcon />
      )}
    </div>
  );
};

export const BODY_CONTENT_GENERATE: Record<
  keyof InvitedBrokerTable,
  (cellProps: CellProps) => React.ReactNode
> = {
  firstName: (cellProps: CellProps) => <NameCell {...cellProps} />,
  email: (cellProps: CellProps) => <EmailCell {...cellProps} />,
  isBrokerAccepted: (cellProps: CellProps) => <AcceptedCell {...cellProps} />,
};
